<div class="info">
  <div class="info-header">
    <div class="container-label">{{ title$ | async }}</div>
    <button
      class="primary-paddingless-text-button"
      [class.disabled]="(showExistingSubmissionBanner$ | async) || disableActionButton"
      (click)="handleEditButtonClick()">
      {{ actionButtonText }}
    </button>
  </div>
</div>
<div *ngIf="showExistingSubmissionBanner$ | async" class="my-4">
  <app-existing-submission-banner (linkClicked)="handleViewSubmissionClicked()" />
</div>
<div class="info-container">
  <div class="data-container" [ngClass]="{ 'w-100': item?.fullWidth }" *ngFor="let item of items">
    <span class="info-label">{{ item?.infoLabel }}</span>
    <div class="d-flex justify-content-between">
      <ng-container *ngTemplateOutlet="nameLabelTemplate; context: { item: item, showFullSin$: showFullSin$ }" />
      <div
        class="item-tooltip-container"
        *ngIf="item?.tooltip"
        [ngbTooltip]="item?.tooltip"
        [triggers]="'hover focus click'">
        <img class="item-tooltip" [src]="'assets/icons/dark/CircleQuestion.svg'" alt="" />
      </div>
    </div>
  </div>
</div>

<ng-template #nameLabelTemplate let-item="item" let-showFullSin$="showFullSin$">
  <div class="name-label flex-fill justify-content-between gap-3">
    <div
      [ngClass]="{ clickable: !!item?.url }"
      [class.sin-number]="item?.isSinNumber"
      (click)="navigateToLink(item?.url)">
      {{
        item?.isSinNumber
          ? (item?.value | maskSinNumber : (showFullSin$ | async) ?? false : item?.isSinNumber)
          : item?.value ?? '-'
      }}
    </div>
    <div *ngIf="item?.isSinNumber && item?.canViewFullSin">
      <button (click)="toggleSin($event)" class="eye">
        <img [src]="sinButtonIcon$ | async" alt="eye-icon" i18n-alt />
      </button>
    </div>
  </div>
</ng-template>
